import { render, staticRenderFns } from "./TourRewards.vue?vue&type=template&id=43ea7e6d&scoped=true&"
import script from "./TourRewards.vue?vue&type=script&lang=js&"
export * from "./TourRewards.vue?vue&type=script&lang=js&"
import style0 from "./TourRewards.vue?vue&type=style&index=0&id=43ea7e6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ea7e6d",
  null
  
)

export default component.exports